import { DOWNLOAD_ENTRY_KINDS, DOWNLOAD_START_FAILURE_STAGES, } from '../../constants';
import { toErrorMessage } from '../telemetry';
// Only an external file's own failed first read implicates the bucket it points
// at; a login or worker failure says nothing about it.
const shouldSuggestCorsSettings = (downloadArgs, failureStage) => Boolean(downloadArgs.isCustomStorage) ||
    (downloadArgs.kind === DOWNLOAD_ENTRY_KINDS.FILE &&
        downloadArgs.isExternalFile &&
        failureStage === DOWNLOAD_START_FAILURE_STAGES.DOWNLOAD_START);
export const createDownloadReporter = ({ downloadArgs, entryFacts, retryFacts, showDownloadStartFailedModal, }) => {
    const { fsId, isCustomStorage, onDownloadComplete, onDownloadFail, onDownloadStart, onDownloadStartFail, workspaceId, } = downloadArgs;
    const eventBase = { fsId, workspaceId };
    return {
        complete: (transferFacts, downloadTime) => onDownloadComplete({
            ...eventBase,
            downloadTime,
            ...transferFacts,
        }),
        fail: (transferFacts, downloadTime, error, failureReason, diagnostics) => onDownloadFail({
            ...eventBase,
            downloadTime,
            errorMessage: toErrorMessage(error),
            failureReason,
            ...diagnostics,
            ...retryFacts(),
            ...transferFacts,
        }),
        start: () => onDownloadStart({ ...eventBase, ...entryFacts }),
        startFail: (error, failureStage) => {
            onDownloadStartFail({
                ...eventBase,
                errorMessage: toErrorMessage(error),
                failureStage,
                isCustomFilespace: Boolean(isCustomStorage),
                isOffline: !navigator.onLine,
                ...entryFacts,
            });
            showDownloadStartFailedModal(shouldSuggestCorsSettings(downloadArgs, failureStage));
        },
    };
};
